import { render } from "./UiAbschreibungsraten.pug?vue&type=template&id=8b57a12e&lang=pug"
import script from "./UiAbschreibungsraten.js?vue&type=script&lang=js"
export * from "./UiAbschreibungsraten.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__